export const RETRY = 'retry';
export const FIX = 'fix';
export const REVERT = 'revert';
